import React from 'react';
import PersonalInfoContainer from '../PersonalInfo/PersonalInfoContainer';
import ChangePasswordActions from './ChangePasswordActions';
import ChangePasswordStore from './ChangePasswordStore';
import {TextField} from '../../FormFields/formFields';

export default class ChangePasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
    this.registerErrors = this.registerErrors.bind(this);
    this.finished = this.finished.bind(this);
    this.state = ChangePasswordStore.getState();
    this.validationRules = {
      currentPassword: {
        required: true,
        requiredMessage: this.props.resources["PWS.ChangePassword.CurrentPasswordRequired"]
      },
      password: {
        required: true,
        requiredMessage: this.props.resources["PWS.ChangePassword.PasswordRequired"]
      },
      confirmPassword: {
        required: true,
        requiredMessage: this.props.resources["PWS.ChangePassword.ConfirmPasswordRequired"],
        mustMatch: () => {
            return this.state.password;
        },
        mustMatchMessage:  this.props.resources["PWS.ChangePassword.MustMatchMessage"]
      }
    };
  }

  componentDidMount() {
      ChangePasswordStore.listen(this.onChange);
  }

  componentWillUnmount() {
      ChangePasswordStore.unlisten(this.onChange);
  }

  onChange(state) {
      this.setState(state);
  }

  canSubmit(fields) {
    return (
        this.refs.currentPassword.isValid()
        && this.refs.password.isValid()
        && this.refs.confirmPassword.isValid()
        && this.state.validPassword
    );
  }

  registerErrors() {
    this.refs.currentPassword.isValid();
    this.refs.password.isValid();
    this.refs.confirmPassword.isValid();
  }

  submit() {
    if(!this.canSubmit()){
      this.registerErrors();
      return false;
    }
    ChangePasswordActions.submit({
      currentPassword: this.state.currentPassword,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword
    });
    }

    checkPasswordRules(value) {
        ChangePasswordActions.validatePasswordRequirements(value)
    }

  resetAndLeave() {
    ChangePasswordActions.reset();
    this.props.changeView('PersonalInfo');
  }

  finished() {
    return (
      <div className="site-container animate-in change-password">
        {this.props.resources["PWS.ChangePassword.ChangePasswordSuccess"]}
        <div className="row col-xs-12">
          <button onClick={this.resetAndLeave.bind(this)} className="pull-left basic-submit-button">OK</button>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.finished) {
      return this.finished();
      }

      let displayPasswordRulesError = this.state.passwordExists ? <div className="login-error-message row col-xs-12" dangerouslySetInnerHTML={{ __html: this.props.resources['PWS.ChangePassword.PasswordRulesError'] }}></div> : '';

    return (
      <div className="site-container animate-in change-password">
        <div className="section-wrapper clearfix">
          <div className="row col-xs-12">
            <TextField
              ref="currentPassword"
              name="currentPassword"
              fieldType="password"
              Rules={this.validationRules.currentPassword}
              value={this.state.currentPassword}
              handleChange={ChangePasswordActions.changeField}
              label={window.jenkon.resources["PWS.ChangePassword.OldPassword"]}
              classes="input-bordered input-50"
            />
          </div>

          {displayPasswordRulesError}
          <div className="row col-xs-12">
            <TextField
              ref="password"
              name="password"
              fieldType="password"
              Rules={this.validationRules.password}
              value={this.state.password}
              handleChange={ChangePasswordActions.changeField}
              label={window.jenkon.resources["PWS.ChangePassword.NewPassword"]}
              classes="input-bordered input-50"
              handleBlur={this.checkPasswordRules.bind(this)}
            />
          </div>
          <div className="row col-xs-12">
            <TextField
              ref="confirmPassword"
              name="confirmPassword"
              fieldType="password"
              Rules={this.validationRules.confirmPassword}
              value={this.state.confirmPassword}
              handleChange={ChangePasswordActions.changeField}
              label={window.jenkon.resources["PWS.ChangePassword.ConfirmNewPassword"]}
              classes="input-bordered input-50"
            />
          </div>
          <div className="row col-xs-12">
            <button onClick={this.submit.bind(this)} className="pull-left basic-submit-button">{this.props.resources["PWS.ChangePassword.SaveChanges"]}</button>
            <button onClick={this.resetAndLeave.bind(this)} className="pull-left basic-submit-button">{window.jenkon.resources['PWS.Globals.CancelButton']}</button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/ChangePassword/ChangePasswordContainer.js